// extracted by mini-css-extract-plugin
export default {"drawerList":"ComponentListItem_drawerList__hpVYH","title":"ComponentListItem_title__GD30p","color":"ComponentListItem_color__1Hw2Z","icon":"ComponentListItem_icon__MY-rK"};